import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'

interface HeaderProps {
  component: Component
  locale: LocaleCode
  style: React.CSSProperties
}

export function Header({ component, locale, style }: HeaderProps) {
  const config = component.config as any
  const text = getLocalizedText(config.text, locale)
  const level = config.level || 1

  const Tag = `h${level}` as keyof JSX.IntrinsicElements

  return <Tag style={style}>{text}</Tag>
}
